import { Link } from 'react-router-dom';
import { useKpiHealth, useKpiSummary } from '../hooks/useKpi';
import { Card } from '../components/Card';
import { Section } from '../components/Section';
import { Stat } from '../components/Stat';

export default function Dashboard() {
  const health = useKpiHealth();
  const summary = useKpiSummary({ collection: 'orders' });
  return (
    <Section title="KPIs" description="Panel ligero con enlaces a informes">
      <div className="grid gap-4 md:grid-cols-3">
        <Card title="Estado"><Stat label="Servicio" value={health.data?.status ?? 'Desconocido'} /><p className="text-xs text-gray-500">{health.data?.timestamp}</p></Card>
        <Card title="Resumen"><div className="grid grid-cols-2 gap-2"><Stat label="Total" value={summary.data?.total} /><Stat label="Promedio" value={summary.data?.avg} /><Stat label="Mín" value={summary.data?.min} /><Stat label="Máx" value={summary.data?.max} /></div></Card>
        <Card title="Reportes">
          <nav className="flex flex-col gap-2 text-sm">
            <Link className="text-emerald-700 underline" to="/kpi/timeseries">Series de tiempo</Link>
            <Link className="text-emerald-700 underline" to="/kpi/top">Top</Link>
            <Link className="text-emerald-700 underline" to="/kpi/distribution">Distribución</Link>
            <Link className="text-emerald-700 underline" to="/kpi/funnel">Embudo</Link>
            <Link className="text-emerald-700 underline" to="/kpi/anomalies">Anomalías</Link>
            <Link className="text-emerald-700 underline" to="/kpi/docs">Docs</Link>
          </nav>
        </Card>
      </div>
    </Section>
  );
}
